<div class="row content__grid">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box">
      <div class="row align-items-center">
        <div class="col-sm-6 col-md-6 col-sm-6 col-6">
          <!-- <h4 class="page-title content__title">Lista marcas</h4> -->
          <a class="page-title form__head__title" (click)="cancel()">
            <i class="fas fa-arrow-left m-r-5"></i> Cuadres de hotel
          </a>
        </div>
        <div class="col-sm-6 col-sm-6 col-md-6 col-sm-6 col-6 content__boxBtnHead">
          <ng-container>
            <a routerLink="/{{branchofficeSlug}}/reportes/cuadreshotel/nuevo" class="btn btn-primary">
              <i class="fa fa-plus m-r-5"></i> Crear cuadre </a>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="card content__grid__card">
      <div class="card-body content__grid__cardbody">
        <div class="content__subhead">
          <div class="row">
            <div class="col-lg-7 col-md-7 col-sm-6 col-12 content__subhead__boxBtns">
              <button type="button" class="btn btn-light btn-sm" title="Actualizar" (click)="refresh()">
                <i class="fas fa-undo"></i></button>
            </div>
            <div class="col-lg-5 col-md-5 col-sm-6 col-12">
              <component-search (searchEvent)="search($event)"></component-search>
            </div>
          </div>
        </div>
        <div class="content__boxTble">
          <div class="table-responsive">
            <table class="table table-hover mb-0">
              <thead class="thead-default">
                <tr>
                  <th>Código</th>
                  <th class="text-center">Hotel</th>
                  <th class="text-center">Rango fechas</th>
                  <th class="text-center">Total Cuadre</th>
                  <!-- <th class="text-center">Total Pagado</th>
                  <th class="text-center">Saldo pendiente</th> -->
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="items.length == 0">
                  <td colspan="4"><span>No se encontraron registros</span></td>
                </ng-container>
                <ng-container *ngIf="items.length > 0">
                  <tr
                    *ngFor="let item of items | paginate: { itemsPerPage: dataPagination.pageSize, currentPage: dataPagination.currentPage, totalItems:dataPagination.totalItems }; let i = index">
                    <td>
                      <a class="grid__link" (click)="detail(item.id)" 
                      style="color: purple !important; font-weight: bold;">
                        {{item.code}}
                      </a>
                      <p class="bold f-s-10 m-b-0">
                        Reg. : {{item.created_at | date: 'mediumDate'}}</p>
                    </td>
                    <td class="text-center">
                      {{item.tradename}}
                    </td>
                    <td class="text-center nowrap">
                      {{item.date_start | date:'shortDate'}} - {{item.date_end | date:'shortDate'}}
                    </td>
                    <td class="text-center">
                      {{item.total_block | currency:'S/'}}
                    </td>
                    <td class="text-center">                      
                      <span *ngIf="!item.is_debt" class="badge badge-warning">No liquidado</span>
                      <span *ngIf="item.is_debt" class="badge badge-success">Liquidado</span>
                    </td>
                    <!-- <td class="text-center">
                      <span class="text-success">{{item.total_paid | currency:'S/'}}</span>
                    </td>
                    <td class="text-center">
                      {{item.total_balance| currency:'S/'}}
                    </td> -->
                    <!-- <td>
                      <div class="btn-group mo-mb-2">
                        <button class="btn btn-light btn-dots btn-sm dropdown-toggle" type="button"
                          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          <i class="fas fa-ellipsis-h"></i>
                        </button>
                        <div class="dropdown-menu" x-placement="bottom-start">
                          <a class="dropdown-item pointer" ng-click="edit(data)">
                            <i class="far fa-edit m-r-5 text-success"></i>Editar
                          </a>
                          <a class="dropdown-item pointer" ng-click="delete(data)">
                            <i class="far fa-trash-alt m-r-5 text-danger"></i>Eliminar
                          </a>
                        </div>
                      </div>
                    </td> -->
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-md-12 ">
          <div class="row content_pagination">
            <div class="col-lg-4">
              <p class="pagination__label">Total <span class="bold">{{dataPagination.totalItems}}</span> registros.</p>
            </div>
            <div class="text-right col-lg-8">
              <ng-container *ngIf="items.length > 0">
                <app-pagination (paginateEvent)="handlePageChange($event)"></app-pagination>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
